import React from 'react';
import { t } from 'Src/i18n';
import { tripsHaveSchedules } from 'Components/widgets/transport-details/transportUtils';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { Notification } from 'Components/frameworks/notification/Notification';
import { ICONS } from 'Components/utils/icon/icons';
import { SimpleNotification } from 'Components/frameworks/notification/SimpleNotification';
import { TransportTicket } from 'Components/widgets/be-transport-details/TransportTicket';
type BeTransportDetailsProps = {
  isComparator?: boolean;
  isTransportRecommended?: boolean;
  withoutTitle?: boolean;
  transport?: Transport;
};
export function BeTransportDetails({
  isComparator,
  isTransportRecommended,
  withoutTitle,
  transport,
}: BeTransportDetailsProps) {
  const { isTablet } = useResponsive();
  const hasSchedules = tripsHaveSchedules(transport?.inbound, transport?.outbound);
  const theme = isComparator || !isTablet ? 'mobile' : 'desktop';

  if (!transport?.inbound && !transport?.outbound) {
    return (
      <Notification
        className="text-red"
        text={t('common.transport.errors.displayErrorDescription')}
      />
    );
  }

  return (
    <div data-testid="BeTransportDetails">
      {!withoutTitle && (
        <div className="mb-20 text-28 font-bold">{t('booking.transport.title')}</div>
      )}
      {!hasSchedules && (
        <SimpleNotification
          id="TransportCharterInformations"
          title={t('common.transport.warnings.reassuranceTitle')}
          content={t('common.transport.warnings.reassuranceMessageNoInformation')}
          className="mb-20"
          iconName={ICONS.LIGHTBULB}
        />
      )}
      <TransportTicket
        theme={theme}
        isTransportRecommended={isTransportRecommended}
        transport={transport}
        isSelected
      />
    </div>
  );
}
